// src/App.js
import "./App.css";
import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import CustomerForm from "./CustomerForm";
import AdminPanel from "./AdminPanel";

const App = () => {
  return (
    <Router>
      {/* Use Helmet to update the document's head */}
      <Helmet>
        <title>X8Printing</title>
        <link rel="icon" href="%PUBLIC_URL%/favicon.ico" />
      </Helmet>
      <div>
        <nav style={{ padding: "10px", background: "#eee" }}>
          <Link to="/" style={{ marginRight: "10px" }}>
            Customer Order Form
          </Link>
          {/* You might choose to hide this link from customers once you add proper authentication */}
          <Link to="/admin">Admin Panel</Link>
        </nav>
        <Routes>
          <Route path="/" element={<CustomerForm />} />
          <Route path="/admin" element={<AdminPanel />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;